import { render, staticRenderFns } from "./AccountConfirm.vue?vue&type=template&id=e64e1e6a&scoped=true&"
import script from "./AccountConfirm.vue?vue&type=script&lang=js&"
export * from "./AccountConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AccountConfirm.vue?vue&type=style&index=0&id=e64e1e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64e1e6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VLayout})
